/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {DeadwoodRipSymbolConfig} from "../../../game/symbol/DeadwoodRipSymbolConfig";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {IBaseSymbol} from "../../symbol/BaseSymbol";

export interface IParsedStackedSymbolName {
    isStacked:boolean;
    symName:string;
    totalNum:number;
    index:number;
}

export class SymbolStack {

    public readonly symName:string;
    public readonly totalNum:number;
    public readonly symbols:(IBaseSymbol | null)[];

    constructor(symName:string, totalNum:number) {
        this.symName = symName;
        this.totalNum = totalNum;
        this.symbols = ArrayHelper.initArrayWithValues(totalNum, (index:number) => null);
    }

    public addSymbol(symbol:IBaseSymbol):void {
        if(this.verifySymbol(symbol)) {
            if(this.symbols[symbol.stackedSymbolName!.index] != null) {
                debugger;
                throw new Error(`SymbolStack.addSymbol():There is symbol exist in the index where the symbol is going to be added!`);
            }
            this.symbols[symbol.stackedSymbolName!.index] = symbol;
        }
    }

    public removeSymbol(symbol:IBaseSymbol):void {
        if(this.verifySymbol(symbol)) {
            if(this.symbols[symbol.stackedSymbolName!.index] != symbol) {
                debugger;
                throw new Error(`SymbolStack.removeSymbol():The index of the symbol to be removed does not match the stack!`);
            }
            this.symbols[symbol.stackedSymbolName!.index] = null;
        }
    }

    private verifySymbol(symbol:IBaseSymbol):boolean {
        if(!symbol.stackedSymbolName!.isStacked) {
            return false;
        }

        if(symbol.stackedSymbolName!.symName != this.symName) {
            return false;
        }

        return true;
    }
}

export class StackedSymbol {

    public static parseStackedSymbolName(symName:string, reelId:number):IParsedStackedSymbolName {
        if(symName == null) {
            debugger;
            throw new Error(`StackedReelSymbol.parseStackedSymbol(): symName cannot be null!`);
        }

        const names:string[] = symName.split("*");
        const totalNum = DeadwoodRipSymbolConfig.SYMBOLS[names[0]]?.stackedTotalNum;
        if(totalNum == null) {
            return {
                isStacked : false,
                symName : symName,
                totalNum : 1,
                index : 0
            }
        }

        const reelTotalNum:number = typeof totalNum === 'number' ? totalNum : (<number[]>totalNum)[reelId];
        return {
            isStacked : reelTotalNum > 1,
            symName : names[0],
            totalNum : reelTotalNum,
            index : reelTotalNum > 1 ? parseInt(names[1]) : 0
        };
    }

    // This function fixes the stack in neighbor symbols and update their visibilities.
    // indexOffset = targetSymbol.stackedSymName.index - compareSymbol.stackedSymName.index
    public static updateStackedSymbols(targetSymbol:IBaseSymbol, compareSymbol:IBaseSymbol | undefined | null, indexOffset:1 | -1, isNewSymbol:boolean):void {
        if(!targetSymbol.stackedSymbolName.isStacked) {
            return;
        }

        // Start a new stack.
        if(compareSymbol == null || !compareSymbol.stackedSymbolName!.isStacked || compareSymbol.stackedSymbolName!.symName != targetSymbol.stackedSymbolName!.symName || this.isNewStackedStackedSymbol(targetSymbol, compareSymbol, indexOffset)) {
            if(isNewSymbol) {
                targetSymbol.stack = new SymbolStack(targetSymbol.stackedSymbolName!.symName, targetSymbol.stackedSymbolName!.totalNum);
            }
            targetSymbol.visible = true;
            return;
        }

        // add target symbol to the same stack as compare symbol
        const actualOffset:number = targetSymbol.stackedSymbolName!.index - compareSymbol.stackedSymbolName!.index;
        if(actualOffset != indexOffset) {
            debugger;
            throw new Error(`ReelController.updateStackedSymbols():Stacked Symbol index error at reel ${targetSymbol.reelId}! targetSymbol = ${targetSymbol.symbolName}, compareSymbol = ${compareSymbol.symbolName}`);
        }

        if(isNewSymbol) {
            targetSymbol.stack = compareSymbol.stack;
        }

        // The bottom one is always visible.
        if(indexOffset > 0) {
            // target is below
            compareSymbol.visible = false;
        } else {
            // compare is below
            targetSymbol.visible = false;
        }
    }

    private static isNewStackedStackedSymbol(targetSymbol:IBaseSymbol, compareSymbol:IBaseSymbol, indexOffset:1 | -1):boolean {
        // a continue stack.
        if(compareSymbol.stackedSymbolName!.index + indexOffset === targetSymbol.stackedSymbolName!.index) {
            return false;
        }

        // Start a new stack.
        return ArrayHelper.reviseIndexInLoopRange(compareSymbol.stackedSymbolName!.totalNum, compareSymbol.stackedSymbolName!.index + indexOffset) === targetSymbol.stackedSymbolName!.index;
    }

    public static filterStackedSymbolsReelSet(reelSet:string[], reelId:number):string[] {
        const result:string[] = [];

        let currentSymbol:string = "";
        let currentIndex:number = -1;
        let currentTotalNum:number = 0;

        for(let symbol of reelSet) {
            const stackedName:IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(symbol, reelId);
            // Not a stacked symbol
            if(!stackedName.isStacked) {
                result.push(symbol);

                // Check previous stacked symbol complete.
                if(currentIndex != (currentTotalNum - 1)) {
                    debugger;
                    throw new Error("StateReelSymbol.filterStackedSymbolsReelSet():Broken stacked symbol error_1!");
                }
                currentSymbol = "";
                currentIndex = -1;
                currentTotalNum = 0;

                continue;
            }

            // A stacked symbol

            // Start a new stacked symbol.
            if(currentSymbol === "" || stackedName.symName != currentSymbol) {
                // Check previous stacked symbol complete.
                if(currentIndex != (currentTotalNum - 1)) {
                    debugger;
                    throw new Error("StateReelSymbol.filterStackedSymbolsReelSet():Broken stacked symbol error_2!");
                }

                currentSymbol = symbol;
                currentIndex = -1;
                currentTotalNum = stackedName.totalNum;
            }

            currentIndex++;
            if(currentIndex >= currentTotalNum) {
                // same stacked symbol next to each other.
                currentIndex = 0;
            }
            result.push(`${symbol}*${currentIndex.toString()}`);
        }

        return result;
    }
}